import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseEntityReloadResolver2, BaseEntityResolver } from './resolver.helper';
import { State } from '../State';
import {
    getTextTemplateTagFetched,
    getTextTemplateTagLatestUpdatedAt,
} from '../State/selectors/text-template-tag.selector';
import { TextTemplateTagActionTypes } from '../State/actions/text-template-tag.actions';



@Injectable({
    providedIn: 'root',
})
export class TextTemplateTagResolver extends BaseEntityReloadResolver2 {
    constructor(store: Store<State>) {
        super(getTextTemplateTagFetched, getTextTemplateTagLatestUpdatedAt, TextTemplateTagActionTypes.Load, store);
    }
}
